import React from "react";

interface FeeChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onViewNotice: () => void;
}

const FeeChangeModal: React.FC<FeeChangeModalProps> = ({
  isOpen,
  onClose,
  onViewNotice,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4">
        {/* 이모지 */}
        <div className="text-center mb-4">
          <div className="text-6xl">📢</div>
        </div>

        {/* 텍스트들 */}
        <div className="text-center space-y-3 mb-6">
          <h2 className="text-xl font-bold text-gray-800">
            할인율&수수료 관련 <br />
            변경사항이 있어요
          </h2>
          <p className="text-gray-600">어떻게 되나 확인해봐요!</p>
          <p className="text-sm text-orange-600 font-medium">
            (25년 12월부터 적용)
          </p>
          <p className="text-sm text-gray-500">공지에서 다시 볼 수 있어요</p>
        </div>

        {/* 버튼들 */}
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-4 bg-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-300 transition-colors"
          >
            닫기
          </button>
          <button
            onClick={onViewNotice}
            className="flex-1 py-3 px-4 bg-[#1562fc] text-white rounded-xl font-medium hover:bg-[#124ab7] transition-colors"
          >
            보러가기
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeeChangeModal;
